import $ from 'jquery';

$.addInit(function(context){
	var base = '.i-rating-item';
	$(base, context).each(function(){
		var component = $(this);

		var rating = component.data('rating');

		component.hover(function(){
			component.prevAll().addBack().toggleClass('m-hover');
		});

		component.on('click', function(){
			component.siblings().removeClass('m-active')
			component.prevAll().addBack().addClass('m-active');

			var hiddenInput = component.closest('.i-rating').prev('.i-inputRating');
			hiddenInput.val(rating);
		});

	});
});

